import { Outlet } from 'react-router-dom'
import { TabsNavigation } from '@/components/Tabs/TabsNavigation'
import type { TabNavigationItem } from '@/components/Tabs/TabsNavigation'
import styles from './SouDistribuidorAfiliadosTabsLayout.module.css'

const TAB_LISTA: TabNavigationItem = {
  value: 'lista',
  label: 'Lista',
  icon: 'mdi:format-list-bulleted',
  to: '/sou-distribuidor/afiliados/lista',
}

const TAB_LINKS: TabNavigationItem = {
  value: 'links',
  label: 'Links',
  icon: 'mdi:link-variant',
  to: '/sou-distribuidor/afiliados/links',
}

const TAB_VENDAS: TabNavigationItem = {
  value: 'vendas',
  label: 'Vendas',
  icon: 'mdi:receipt-text-outline',
  to: '/sou-distribuidor/afiliados/vendas',
}

const TAB_SALDO: TabNavigationItem = {
  value: 'saldo',
  label: 'Saldo afiliados',
  icon: 'mdi:wallet-outline',
  to: '/sou-distribuidor/afiliados/saldo',
}

const TABS = [TAB_LISTA, TAB_LINKS, TAB_VENDAS, TAB_SALDO] as const

export function SouDistribuidorAfiliadosTabsLayout() {
  return (
    <div className={styles.wrap}>
      <TabsNavigation tabs={[...TABS]} aria-label="Afiliados do distribuidor" />
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  )
}
